<div
  class="upload-container"
  [ngClass]="{
    'title-side': config.titlePosition !== 'above',
    'title-top': config.titlePosition === 'above',
  }"
>
  @if (config.showTitle !== false || config.showDescription !== false) {
    <div class="upload-info">
      @if (config.showTitle !== false) {
        <h1 class="title" [ngClass]="{ 'title-bold': config.titleBold }">
          {{ config.customTitle || "Áreas de interesse" }}
        </h1>
      }
      @if (config.showDescription !== false) {
        <p [innerHTML]="currentDescription"></p>
      }

      <!-- Radio group para seleção de tipo de arquivo -->
      @if (config.showFileTypeSelector) {
        <div class="file-type-selector">
          <mat-radio-group
            [(ngModel)]="selectedFileType"
            (change)="onFileTypeChange()"
            color="primary"
          >
            @for (type of ["spreadsheet", "kml", "shapefile"]; track type) {
              @if (
                (config.enabledFileTypes || ["shapefile"]).includes($any(type))
              ) {
                @if (type === "spreadsheet") {
                  <mat-radio-button value="spreadsheet">
                    Planilha excel
                  </mat-radio-button>
                }
                @if (type === "kml") {
                  <mat-radio-button value="kml">
                    KML/KMZ (Google Earth)
                  </mat-radio-button>
                }
                @if (type === "shapefile") {
                  <mat-radio-button value="shapefile">
                    Shapefile
                  </mat-radio-button>
                }
              }
            }
          </mat-radio-group>
        </div>
      }

      <div class="upload-error">
        @if (fileCtrl.hasError(errorCodes.maxSize)) {
          <mat-error> Arquivo maior que {{ currentMaxSizeMB }} MB </mat-error>
        }
        @if (fileCtrl.hasError(errorCodes.fileType)) {
          <mat-error>
            {{ getAcceptErrorMessage() }}
          </mat-error>
        }
        @if (fileCtrl.hasError(errorCodes.geometryType)) {
          <mat-error>
            O arquivo contém feições diferentes de Polygon e MultiPolygon.
          </mat-error>
        }

        <!-- Erros específicos de KML -->
        @if (fileCtrl.hasError("notGoogleEarth")) {
          <mat-error>
            O arquivo KML/KMZ não foi criado no Google Earth.
          </mat-error>
        }
        @if (fileCtrl.hasError("lowConfidence")) {
          <mat-error>
            O arquivo tem baixa confiança de ser do Google Earth.
          </mat-error>
        }
        @if (fileCtrl.hasError("kmlError")) {
          <mat-error>
            {{
              fileCtrl.errors?.["kmlError"]?.message ||
                "Erro ao processar arquivo KML/KMZ"
            }}
          </mat-error>
        }

        @for (e of unprocessableContentReasons; track $index) {
          @if (fileCtrl.hasError(e)) {
            <mat-error>{{ unprocessableContentMessagesPtBr[e] }}</mat-error>
          }
        }

        <!-- Erros de validação DBF -->
        @if (fileCtrl.hasError("dbfValidation")) {
          <mat-error>
            <strong>Erros na validação do arquivo DBF:</strong>
            @if (
              fileCtrl.errors?.["dbfValidation"]?.missingFields?.length > 0
            ) {
              <div>Campos obrigatórios ausentes:</div>
              <ul>
                @for (
                  field of fileCtrl.errors?.["dbfValidation"]?.missingFields;
                  track field
                ) {
                  <li>{{ field }}</li>
                }
              </ul>
            }
            @if (
              fileCtrl.errors?.["dbfValidation"]?.validationErrors?.length > 0
            ) {
              <div>Erros de dados:</div>
              <ul>
                @for (
                  error of fileCtrl.errors?.["dbfValidation"]?.validationErrors;
                  track error
                ) {
                  <li [innerHTML]="error"></li>
                }
              </ul>
            }
            @if (fileCtrl.errors?.["dbfValidation"]?.error) {
              <div>{{ fileCtrl.errors?.["dbfValidation"]?.error }}</div>
            }
          </mat-error>
        }

        <!-- Erros de validação FGB -->
        @if (fileCtrl.hasError("fgbValidation")) {
          <mat-error>
            <strong>Erros na validação do arquivo FGB:</strong>
            @if (
              fileCtrl.errors?.["fgbValidation"]?.missingFields?.length > 0
            ) {
              <div>Campos obrigatórios ausentes:</div>
              <ul>
                @for (
                  field of fileCtrl.errors?.["fgbValidation"]?.missingFields;
                  track field
                ) {
                  <li>{{ field }}</li>
                }
              </ul>
            }
            @if (
              fileCtrl.errors?.["fgbValidation"]?.validationErrors?.length > 0
            ) {
              <div>Erros de dados:</div>
              <ul>
                @for (
                  error of fileCtrl.errors?.["fgbValidation"]?.validationErrors;
                  track error
                ) {
                  <li [innerHTML]="error"></li>
                }
              </ul>
            }
            @if (fileCtrl.errors?.["fgbValidation"]?.error) {
              <div>{{ fileCtrl.errors?.["fgbValidation"]?.error }}</div>
            }
          </mat-error>
        }

        <!-- Erros de validação Excel -->
        @if (fileCtrl.hasError("excelValidation")) {
          <mat-error>
            <!-- Sempre exibir formato agregado (sem fallback linha a linha) -->
            <strong>{{
              fileCtrl.errors?.["excelValidation"]?.message ||
                "O arquivo informado não possui informações válidas"
            }}</strong>

            @if (fileCtrl.errors?.["excelValidation"]?.summary) {
              <div style="margin-top: 8px">
                <strong>Campos com problema:</strong>
                <ul style="margin: 4px 0; padding-left: 20px">
                  @for (
                    field of fileCtrl.errors?.["excelValidation"]?.summary
                      ?.fields;
                    track field.field
                  ) {
                    <li>
                      <strong>{{ field.field }}</strong
                      >: {{ field.invalidRows }} linhas
                      @if (field.reasons && field.reasons.length > 0) {
                        <span style="font-size: 0.9em; color: #666">
                          ({{ field.reasons[0] }})
                        </span>
                      }
                    </li>
                  }
                </ul>
                <div style="margin-top: 8px">
                  <strong>Total de linhas com problema: </strong>
                  {{
                    fileCtrl.errors?.["excelValidation"]?.summary
                      ?.totalInvalidRows
                  }}
                </div>
              </div>
            }
          </mat-error>
        }
      </div>
    </div>
  }
  <mat-form-field appearance="outline" class="drop-field dashed-outline">
    <ngx-mat-dropzone class="drop-zone">
      <input
        type="file"
        fileInput
        [formControl]="fileCtrl"
        [accept]="currentAcceptTypes"
      />
      @if (file === null) {
        <mat-chip-row class="drop-field-chip">
          <div class="drop-field-text">
            <mat-icon class="upload-icon">upload</mat-icon>
            {{
              config.customDescriptionUpload ||
                "Clique aqui ou arraste arquivo para fazer upload"
            }}
          </div>
        </mat-chip-row>
      } @else {
        <mat-chip-row (removed)="remove()" class="chip-drop">
          @if (loadingService.button$ | async) {
            <mat-spinner matChipAvatar diameter="18"></mat-spinner>
          }
          {{ file.name }}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </ngx-mat-dropzone>
    <mat-hint>
      <!-- Link para baixar template Excel - aparece abaixo do upload -->
      @if (
        config.showFileTypeSelector && selectedFileType() === "spreadsheet"
      ) {
        <div class="excel-template-link">
          <span>Baixar e preencher a </span>
          <a
            class="template-link"
            (click)="downloadExcelTemplate()"
            [class.disabled]="isDownloadingTemplate()"
          >
            @if (isDownloadingTemplate()) {
              <mat-spinner diameter="16"></mat-spinner>
              <span>baixando...</span>
            } @else {
              <mat-icon class="download-icon">download</mat-icon>
              <span>planilha modelo</span>
            }
          </a>
          <button
            mat-icon-button
            class="help-icon"
            [matTooltip]="'Faça o download da planilha modelo, preencha com os dados das áreas e envie o arquivo preenchido através do upload acima.'"
            matTooltipPosition="right"
          >
            <mat-icon>help</mat-icon>
          </button>
        </div>
      }
    </mat-hint>
  </mat-form-field>
</div>
